import React from 'react'
import { Link } from 'react-router-dom'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faArrowLeft } from '@fortawesome/free-solid-svg-icons'

/**
 * Kerangka halaman untuk dokumen hukum (Syarat & Ketentuan, Kebijakan
 * Privasi). Dibuat supaya kedua halaman itu tampil konsisten dan tetap enak
 * dibaca di layar kecil.
 */
const LegalPage = ({ title, updatedAt, children }) => (
  <div className="min-h-screen bg-[#F9FAFB]">
    <div className="mx-auto w-full max-w-3xl px-5 py-10 md:px-8 md:py-14">
      <Link
        to="/"
        className="inline-flex items-center gap-2 text-sm text-[#696A6B] hover:text-[#f3790e] transition-colors"
      >
        <FontAwesomeIcon icon={faArrowLeft} />
        Kembali ke halaman masuk
      </Link>

      <h1 className="mt-6 text-2xl md:text-3xl font-bold text-[#191a1a]">
        {title}
      </h1>
      {updatedAt && (
        <p className="mt-2 text-sm text-[#838489]">
          Terakhir diperbarui: {updatedAt}
        </p>
      )}

      <div className="mt-8 rounded-2xl bg-white p-6 md:p-10 shadow-sm">
        {children}
      </div>
    </div>
  </div>
)

export const Section = ({ number, title, children }) => (
  <section className="mb-8 last:mb-0">
    <h2 className="text-lg font-bold text-[#191a1a]">
      {number}. {title}
    </h2>
    <div className="mt-3 space-y-3 text-sm leading-relaxed text-[#53565D]">
      {children}
    </div>
  </section>
)

export const List = ({ items }) => (
  <ul className="list-disc space-y-2 pl-5">
    {items.map((item, index) => (
      <li key={index}>{item}</li>
    ))}
  </ul>
)

export const Callout = ({ title, children }) => (
  <div className="my-6 rounded-xl border border-[#f3790e]/30 bg-[#FFF4E8] p-5">
    <p className="font-bold text-[#191a1a]">{title}</p>
    <div className="mt-2 space-y-2 text-sm leading-relaxed text-[#53565D]">
      {children}
    </div>
  </div>
)

export default LegalPage
